import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Avatar } from '../components/ui/Avatar';
import { Badge } from '../components/ui/Badge';
import { Modal } from '../components/ui/Modal';
import { Toggle } from '../components/ui/Toggle';
import { useToast } from '../components/ui/Toast';
import { sellers as initialSellers } from '../utils/mockData';
import { QrCode, Smartphone, Bell, Shield, Target, LogOut, RefreshCw, CheckCheck } from 'lucide-react';
export function Configuracoes() {
  const {
    addToast
  } = useToast();
  const [sellers, setSellers] = useState(initialSellers);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [connectingSeller, setConnectingSeller] = useState<string | null>(null);
  const [connectionStep, setConnectionStep] = useState(0);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [autoMoveDeals, setAutoMoveDeals] = useState(false);
  const handleConnect = (sellerId: string) => {
    setConnectingSeller(sellerId);
    setConnectionStep(0);
    setIsQrModalOpen(true);
    setTimeout(() => setConnectionStep(1), 3000);
    setTimeout(() => {
      setConnectionStep(2);
      setSellers(prev => prev.map(s => s.id === sellerId ? {
        ...s,
        whatsappConnected: true
      } : s));
      addToast('WhatsApp conectado com sucesso!', 'success');
      setTimeout(() => setIsQrModalOpen(false), 1500);
    }, 5000);
  };
  const handleDisconnect = (sellerId: string) => {
    if (confirm('Tem certeza que deseja desconectar?')) {
      setSellers(prev => prev.map(s => s.id === sellerId ? {
        ...s,
        whatsappConnected: false
      } : s));
      addToast('WhatsApp desconectado', 'info');
    }
  };
  return <Layout data-id="element-412">
      <div className="space-y-8" data-id="element-413">
        <h1 className="text-3xl font-bold text-white" data-id="element-414">Configurações</h1>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-415">
          <div className="lg:col-span-1 space-y-2" data-id="element-416">
            {[{
            label: 'Conexões WhatsApp',
            icon: Smartphone,
            active: true
          }, {
            label: 'Metas e Objetivos',
            icon: Target
          }, {
            label: 'Notificações',
            icon: Bell
          }, {
            label: 'Usuários',
            icon: Shield
          }].map(item => <button key={item.label} className={`
                  w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-all
                  ${item.active ? 'bg-primary text-white shadow-lg shadow-primary/20' : 'text-text-secondary hover:bg-slate-800 hover:text-white'}
                `} data-id="element-417">
                <item.icon className="h-4 w-4 mr-3" data-id="element-418" />
                {item.label}
              </button>)}
          </div>

          <div className="lg:col-span-3 space-y-6" data-id="element-419">
            <Card className="p-6" data-id="element-420">
              <div className="flex justify-between items-center mb-6" data-id="element-421">
                <div data-id="element-422">
                  <h2 className="text-xl font-bold text-white" data-id="element-423">
                    Conexões WhatsApp
                  </h2>
                  <p className="text-text-muted text-sm" data-id="element-424">
                    Gerencie os números conectados de cada vendedor.
                  </p>
                </div>
                <Button variant="outline" icon={<QrCode className="h-4 w-4" data-id="element-426" />} data-id="element-425">
                  Nova Conexão
                </Button>
              </div>

              <div className="space-y-4" data-id="element-427">
                {sellers.map(seller => <div key={seller.id} className="flex items-center justify-between p-4 bg-slate-800/50 rounded-xl border border-slate-700/50" data-id="element-428">
                    <div className="flex items-center gap-4" data-id="element-429">
                      <Avatar src={seller.avatar} fallback={seller.name} data-id="element-430" />
                      <div data-id="element-431">
                        <p className="font-medium text-white" data-id="element-432">{seller.name}</p>
                        <p className="text-xs text-text-muted" data-id="element-433">
                          {seller.whatsappConnected ? '+55 11 99999-9999' : 'Não conectado'}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-4" data-id="element-434">
                      <Badge variant={seller.whatsappConnected ? 'success' : 'danger'} dot data-id="element-435">
                        {seller.whatsappConnected ? 'Conectado' : 'Desconectado'}
                      </Badge>
                      {seller.whatsappConnected ? <Button size="sm" variant="ghost" onClick={() => handleDisconnect(seller.id)} className="text-red-400 hover:text-red-300 hover:bg-red-500/10" data-id="element-436">
                          <LogOut className="h-4 w-4 mr-2" data-id="element-437" /> Desconectar
                        </Button> : <Button size="sm" variant="primary" onClick={() => handleConnect(seller.id)} data-id="element-438">
                          <QrCode className="h-4 w-4 mr-2" data-id="element-439" /> Conectar
                        </Button>}
                    </div>
                  </div>)}
              </div>
            </Card>

            <Card className="p-6" data-id="element-440">
              <div className="flex justify-between items-center mb-6" data-id="element-441">
                <div data-id="element-442">
                  <h2 className="text-xl font-bold text-white" data-id="element-443">Preferências</h2>
                  <p className="text-text-muted text-sm" data-id="element-444">
                    Personalize sua experiência.
                  </p>
                </div>
              </div>

              <div className="space-y-6" data-id="element-445">
                <Toggle checked={soundEnabled} onChange={setSoundEnabled} label="Sons de Notificação" description="Tocar som ao receber mensagens ou fechar vendas" data-id="element-446" />
                <Toggle checked={notificationsEnabled} onChange={setNotificationsEnabled} label="Notificações Desktop" description="Mostrar popups do navegador" data-id="element-447" />
                <Toggle checked={autoMoveDeals} onChange={setAutoMoveDeals} label="Mover Negócios Automaticamente" description="Avançar etapa baseado na conversa (IA)" data-id="element-448" />
              </div>
            </Card>

            <Card className="p-6" data-id="element-449">
              <div className="flex justify-between items-center mb-6" data-id="element-450">
                <div data-id="element-451">
                  <h2 className="text-xl font-bold text-white" data-id="element-452">
                    Metas Mensais
                  </h2>
                  <p className="text-text-muted text-sm" data-id="element-453">
                    Defina os objetivos de venda da equipe.
                  </p>
                </div>
                <Button variant="ghost" size="sm" data-id="element-454">
                  Salvar Alterações
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-455">
                <Input label="Meta da Equipe (R$)" defaultValue="1.000.000,00" data-id="element-456" />
                <Input label="Meta Individual Padrão (R$)" defaultValue="150.000,00" data-id="element-457" />
              </div>
            </Card>
          </div>
        </div>
      </div>

      <Modal isOpen={isQrModalOpen} onClose={() => setIsQrModalOpen(false)} title="Conectar WhatsApp" size="sm" data-id="element-458">
        <div className="flex flex-col items-center justify-center py-8 text-center" data-id="element-459">
          {connectionStep === 0 && <>
              <div className="bg-white p-4 rounded-xl mb-6" data-id="element-460">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=ExampleConnection" alt="QR Code" className="w-48 h-48" data-id="element-461" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-462">
                Escaneie o QR Code
              </h3>
              <p className="text-sm text-text-muted" data-id="element-463">
                Abra o WhatsApp no seu celular {'>'} Menu {'>'} Aparelhos
                conectados {'>'} Conectar aparelho
              </p>
            </>}

          {connectionStep === 1 && <>
              <div className="w-20 h-20 border-4 border-primary border-t-transparent rounded-full animate-spin mb-6" data-id="element-464" />
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-465">
                Conectando...
              </h3>
              <p className="text-sm text-text-muted" data-id="element-466">
                Aguarde enquanto estabelecemos a conexão.
              </p>
            </>}

          {connectionStep === 2 && <>
              <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center mb-6 animate-in zoom-in" data-id="element-467">
                <CheckCheck className="h-10 w-10 text-white" data-id="element-468" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-469">Conectado!</h3>
              <p className="text-sm text-text-muted" data-id="element-470">
                O número foi vinculado com sucesso.
              </p>
            </>}
        </div>
      </Modal>
    </Layout>;
}